import {Component, OnInit} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {Loader} from '../../models/loader/loader.redux';
import {PDfTemplateAction} from '../../models/pdf-template';
import {Store} from '@ngxs/store';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {ServiceAction, ServiceState} from '../../models/service';
import {cloneDeep} from 'lodash';
import {ActivatedRoute, Params} from '@angular/router';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';
import {fadeInAnimation} from '../../animations/fade-in.animation';

@Component({
  selector: 'app-download-patient-template',
  templateUrl: './download-patient-template.component.html',
  styleUrls: ['./download-patient-template.component.scss'],
  animations: [fadeInAnimation]
})
export class DownloadPatientTemplateComponent implements OnInit {

  serviceId: string;
  patientId: string;
  async ngOnInit(): Promise<void> {
    await this.initValues();
  }

  constructor(
    private store: Store,
    private messageAlertService: MessageAlertService,
    private utilitiesServices: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
  ) {
  }

  async initValues(): Promise<void> {
    const params: Params = this.utilitiesServices.getAllParams(this.activatedRoute);
    this.patientId = params.patientId;

    let service = cloneDeep(await firstValueFrom((this.store.selectOnce(ServiceState.getActive))));
    if (service === null) {
      const user = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
      const expertId = user?.experts[0]._id;
      await firstValueFrom((this.store.dispatch(new ServiceAction.GetActive(this.patientId, expertId))));
    }
    service = cloneDeep(await firstValueFrom((this.store.selectOnce(ServiceState.getActive))));
    this.serviceId = service?._id;
  }

  async onDownloadPdfTemplate(): Promise<void> {
    try {
      await firstValueFrom(this.store.dispatch(new Loader(true, 'Descargando plantilla ...')));
      await firstValueFrom(this.store.dispatch(new PDfTemplateAction.Download(this.serviceId, this.patientId)));
      this.messageAlertService.createMessage('success', 'Plantilla descargada con éxito');
    } catch (e) {
      console.log(e);
      this.messageAlertService.createMessage('error', 'No se ha podido descargar la plantilla.');
    } finally {
      await firstValueFrom(this.store.dispatch(new Loader(false)));
    }
  }
}
